// extracted by mini-css-extract-plugin
export var backgroundImage = "_f-1";
export var container = "_f-0";
export var title = "_f-2";